import { useState } from 'react';
import { HomeNavButton } from './NavButtons';
import { verifyParentPassword } from '../services/parentService';

const inputClassName =
  'mt-2 w-full rounded-[12px] border border-slate-200 bg-[#F8F8F8] px-4 py-3 text-[13px] outline-none transition focus:border-[#1FC24E] focus:bg-white';

function ParentPasswordGate({ children }) {
  const [isVerified, setIsVerified] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const isValid = await verifyParentPassword(password);

      if (isValid) {
        setIsVerified(true);
        return;
      }

      setError('رمز والد نامعتبر است');
    } catch (caughtError) {
      setError(caughtError.message || 'رمز والد نامعتبر است');
    } finally {
      setIsLoading(false);
    }
  }

  if (isVerified) {
    return children;
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <p
            style={{
              background: 'linear-gradient(90deg, #7FDE86 0%, #1FC24E 100%)',
              boxShadow: '4px 5px 11px rgba(0, 0, 0, 0.07)',
            }}
            className="rounded-[10px] px-6 py-1 text-[15px] text-white"
          >
            پنجره اولیا
          </p>

          <img className="h-[50px]" src="/images/parent.webp" alt="" />
        </div>

        <HomeNavButton />
      </div>

      <div className="rounded-[10px] bg-white p-5 shadow-[0_4px_14px_rgba(15,23,42,0.06)]">
        <p className="text-[13px] font-bold text-slate-800">ورود به بخش والدین</p>
        <p className="mt-2 text-[11px] leading-6 text-slate-500">
          برای مشاهده اطلاعات این بخش، رمز اختصاصی والدین را وارد کنید.
        </p>

        <form className="mt-5 space-y-4" onSubmit={handleSubmit}>
          <label className="block text-[12px] text-slate-700">
            رمز والدین
            <input
              className={inputClassName}
              type="password"
              autoComplete="off"
              placeholder="رمز والدین را وارد کنید"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>

          <button
            type="submit"
            className="w-full rounded-[12px] bg-[#1FC24E] py-2.5 text-[13px] font-bold text-white disabled:cursor-not-allowed disabled:opacity-60"
            disabled={isLoading}
          >
            {isLoading ? 'در حال بررسی...' : 'تایید و ورود'}
          </button>
        </form>

        {error && (
          <p className="mt-4 rounded-[12px] bg-red-50 px-4 py-3 text-[12px] text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
}

export default ParentPasswordGate;
